import { render, staticRenderFns } from "./addCentresList.vue?vue&type=template&id=0648f7f2&scoped=true"
import script from "./addCentresList.vue?vue&type=script&lang=js"
export * from "./addCentresList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0648f7f2",
  null
  
)

export default component.exports